import {FTUETrainerTextProps} from '@skillz/ui';
import SKZConstants from 'SKZConstants';
import {_m} from 'INTL';
import GameOperationsTrainerBase from './GameOperationsTrainerBase';

export default class GameOperationsTrainerStepWelcome
  extends GameOperationsTrainerBase
  implements FTUETrainerTextProps
{
  constructor() {
    super(SKZConstants.ETrainerAssetKey.FaceLeft);
    this.text = _m("Welcome Back!\nWe've made some updates while you were away");
    this.overlayVisible = true;
  }
}
